// extracted by mini-css-extract-plugin
export var line = "style-module--line--vKp8c";
export var root = "style-module--root--LdYk8";
export var text = "style-module--text--Q60R3";
export var title = "style-module--title--j8Yhm";